{
    "dropdown_option__delete": "Supprimer",
    "dropdown_option_release": "Valider dans le système ERP",
    "ORDER__delete_confirmation__title": "Supprimer la commande ?",
    "ORDER__delete_confirmation__description": "La commande est supprimée de Plato et du système ERP. Cette action est irréversible.",
    "QUOTE__delete_confirmation__title": "Supprimer le devis ?",
    "QUOTE__delete_confirmation__description": "Le devis est supprimé de Plato et du système ERP. Cette action est irréversible.",
    "ORDER__delete_toast__success_title": "Commande supprimée avec succès",
    "ORDER__delete_toast__success_description": "Vous pouvez <linkTag>créer une nouvelle transaction</linkTag> ici",
    "QUOTE__delete_toast__success_title": "Devis supprimé avec succès",
    "QUOTE__delete_toast__success_description": "Vous pouvez <linkTag>créer une nouvelle transaction</linkTag> ici",
    "ORDER__release_toast__success_title": "Commande validée avec succès",
    "ORDER__release_toast__success_description": "Vous pouvez <linkTag>créer une nouvelle transaction</linkTag> ici",
    "QUOTE__release_toast__success_title": "Devis validé avec succès",
    "QUOTE__release_toast__success_description": "Vous pouvez <linkTag>créer une nouvelle transaction</linkTag> ici",
    "ORDER__release_confirmation__title": "Valider la commande dans l'ERP ?",
    "ORDER__release_confirmation__description": "Cette action est irréversible. Choisissez si vous souhaitez envoyer au client une confirmation au format PDF dans un e-mail standard.",
    "QUOTE__release_confirmation__title": "Valider le devis dans l'ERP ?",
    "QUOTE__release_confirmation__description": "Cette action est irréversible. Choisissez si vous souhaitez envoyer au client une confirmation au format PDF dans un e-mail standard.",
    "send_pdf_by_email": "Envoyer la confirmation par e-mail",
    "do_not_send_pdf_by_email": "Ne pas envoyer d'e-mail"
}
